import {PHASES} from "../constants/phases";

export const checkIfAnyGamePreparationPhase = (phase) => {
  return phase === PHASES.FIELD_PREPARATION || phase === PHASES.SETUP;
}